export default __webpack_public_path__ + "btn-yel-arrow.png?c30d9e007ffb20a00bab46768761e356";